import script from "./CertificationsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationsSection.vue?vue&type=script&setup=true&lang=js"

import "./CertificationsSection.vue?vue&type=style&index=0&id=c0431d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0431d46"]])

export default __exports__